import styled from '@emotion/styled'
import { Frown } from '@pretamanger/component-library'
import tw from 'twin.macro'

export const Container = styled('div')`
  ${tw`flex justify-center items-center`}
`

export const CustomFrown = styled(Frown)`
  ${tw`w-[26px] h-[26px]`}
`

export const LabelEmptyProducts = styled('p')`
  ${tw`font-normal text-grey-500 text-lg ml-4`}
`
